<template>
  <div>
    <b-row>
      <b-col md="5">
        <template v-if="ADDRESS.funnel_v2">
          <product-summary-headline headline="Ihre gewählte Internetkonfiguration:"/>
          <p>
            <strong>Geschwindigkeit</strong><br/>
            Download: {{ formatNumber(this.SERVICE.internet.download) }}<span> Mbit/s</span> (min. {{ formatNumber(this.SERVICE.internet.downloadMin/1000) }} Mbit/s)<br/>
            Upload: {{ formatNumber(this.SERVICE.internet.upload) }}<span> Mbit/s</span> (min. {{ formatNumber(this.SERVICE.internet.uploadMin/1000) }} Mbit/s)
          </p>
          <p v-if="getOptionList('internetOptions').length > 0">
            <strong>Optionen Internet</strong>
            <br/>
            <ul class="list-unstyled">
              <li v-for="option in getOptionList('internetOptions')" :key="option.id">
                <service-option-item-text
                    :service-option-item="option"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :show-price-primary="true"
                    :additional-title-text="(option.description.toLowerCase().indexOf('upload') > -1 && GET_UPGRADE_UPLOAD_SPEED ? 'auf ' + GET_UPGRADE_UPLOAD_SPEED + ' Mbit/s' : '')"
                />
              </li>
            </ul>
          </p>
          <product-summary-headline headline="Ihr gewählte Hardware:"/>
          <ul class="list-unstyled">
            <template v-if="Array.isArray(CHECKOUT_DATA.hardwareOptions)">
              <li v-for="serviceOption in CHECKOUT_DATA.hardwareOptions" :key="serviceOption.id">
                {{ serviceOption.description }}:
                <span class="text-primary">{{ formatPrice(serviceOption.price) }}</span>
              </li>
            </template>
            <template v-else>
              <li>
                <service-option-item-text
                    :service-option-item="CHECKOUT_DATA.hardwareOptions"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :show-price-primary="true"
                    :show-product-dependencies="CHECKOUT_DATA.hardwareLocale !== '1'"
                />
              </li>
              <li v-if="CHECKOUT_DATA.hardwareLocale === '1'" class="mt-1">
                <strong>Die Hardware wurde vor Ort an VertragspartnerIn übergeben.</strong><br/>
                Router-Typ: {{ CHECKOUT_DATA.custom_hardware.router_type }}<br/>
                CWMP-Account: {{ CHECKOUT_DATA.custom_hardware.cwmp_account }}<br/>
                CMAC-Adresse: {{ CHECKOUT_DATA.custom_hardware.c_mac_address }}
              </li>
            </template>
            <div v-if="CHECKOUT_DATA.hardwareOptions.length == 0">
              Sie haben keine Hardware ausgewählt.
            </div>
          </ul>
          <product-summary-headline headline="Zusammenfassung Ihrer Kosten:"/>
          <p>
            <strong>monatliche Kosten: {{ getPrice() }}</strong> <br/>
            <strong>einmalige Kosten: {{ getPrice2() }}</strong> <br/>
            <template v-if="SERVICE.hasInternet || SERVICE.hasPhone">
              <template v-if="SERVICE.minimumTerm === 1">
                <template v-if="CHECKOUT_DATA.chargeInternetAndPhoneFee">
                  {{ ORDER_FEES['internet_and_phone_flex'].name }}: {{ this.formatPrice(ORDER_FEES['internet_and_phone_flex'].price) }}<br/>
                </template>
              </template>
              <template v-else>
                <template v-if="CHECKOUT_DATA.chargeInternetAndPhoneFee">
                  <strong>{{ ORDER_FEES['internet_and_phone'].name }}: {{ this.formatPrice(ORDER_FEES['internet_and_phone'].price) }}</strong><br/>
                </template>
              </template>
            </template>
            <template v-if="SERVICE.hasTV || hasCableTVOption()">
              <template v-if="CHECKOUT_DATA.chargeCableTvFee">
                <strong>{{ ORDER_FEES['cable_tv'].name }}: {{ this.formatPrice(ORDER_FEES['cable_tv'].price) }}</strong><br/>
              </template>
            </template>
            <template v-if="!CHECKOUT_DATA.chargeInternetAndPhoneFee">
              <template v-if="SERVICE.minimumTerm === 1">
                <strong>
                  {{ ORDER_FEES['internet_and_phone_flex'].name }} in Höhe von {{ this.formatPrice(ORDER_FEES['internet_and_phone_flex'].price) }} wird nicht berechnet.<br/>
                </strong>
              </template>
              <template v-else>
                <strong>
                  {{ ORDER_FEES['internet_and_phone'].name }} in Höhe von {{ this.formatPrice(ORDER_FEES['internet_and_phone'].price) }} wird nicht berechnet.<br/>
                </strong>
              </template>
            </template>
            <template v-if="!CHECKOUT_DATA.chargeCableTvFee">
              <strong>
                {{ ORDER_FEES['cable_tv'].name }} in Höhe von {{ this.formatPrice(ORDER_FEES['cable_tv'].price) }} wird nicht berechnet. <br/>
              </strong>
            </template>
          </p>

          <p class="mt-2 line-height-3">
            <span v-if="SERVICE.discount && SERVICE.discount.months > 0 && false">
                    {{ SERVICE.discount.text }}
                  </span>
            <template class="text-primary font-weight-bold line-height-1" v-if="SERVICE.id.indexOf('GS') > -1">
              Gutschrift (einmalig): <span class="font-medium-5 text-primary">{{ formatPrice(getCreditNote(SERVICE.id)) }}</span>
              <br/>
            </template>
          </p>
          <p class="mt-2" v-if="CHECKOUT_DATA.invoice_paper">
          <span>
            Rechnungsversand (monatlich): 2,50 €
          </span>
          </p>
        </template>
        <template v-else>
          <p class="font-medium-3 font-weight-bold">
            Ihr gewählter Tarif: <span v-if="SERVICE"> {{ SERVICE.name }} </span>
          </p>
          <p class="mt-2 line-height-3">
            <template v-if="SERVICE.discount && SERVICE.discount.price > 0">
              Monatliches Entgelt im 1. - {{ SERVICE.discount.months }}. Monat: <span class="text-primary font-medium-5">{{ formatPrice(SERVICE.discount.price) }}</span><br/>
              Monatliches Entgelt ab {{ SERVICE.discount.months + 1}}. Monat: <span class="text-primary font-medium-5">{{ formatPrice(SERVICE.priceMonthly) }}</span><br/>
              {{ SERVICE.minimumTerm }} Monate Mindestlaufzeit
            </template>
            <template v-else>
              Monatliches Entgelt: <span class="text-primary font-medium-5">{{ formatPrice(SERVICE.priceMonthly) }}</span>
            </template>
            <br/>
            <template class="text-primary font-weight-bold line-height-1" v-if="SERVICE.id.indexOf('GS') > -1">
              Gutschrift (einmalig): <span class="font-medium-5 text-primary">{{ formatPrice(getCreditNote(SERVICE.id)) }}</span>
              <br/>
            </template>
            <template v-if="SERVICE.hasInternet || SERVICE.hasPhone">
              <template v-if="SERVICE.minimumTerm === 1">
                <div v-if="CHECKOUT_DATA.chargeInternetAndPhoneFee">
                {{ ORDER_FEES['internet_and_phone_flex'].name }}: <span class="font-medium-5">{{ this.formatPrice(ORDER_FEES['internet_and_phone_flex'].price) }}</span>
                </div>
              </template>
              <template v-else>
                <div v-if="CHECKOUT_DATA.chargeInternetAndPhoneFee">
                {{ ORDER_FEES['internet_and_phone'].name }}: <span class="font-medium-5">{{ this.formatPrice(ORDER_FEES['internet_and_phone'].price) }}</span>
                </div>
              </template>
            </template>
            <template v-if="SERVICE.hasTV || hasCableTVOption()">
              <div v-if="CHECKOUT_DATA.chargeCableTvFee">
              {{ ORDER_FEES['cable_tv'].name }}: <span class="font-medium-5">{{ this.formatPrice(ORDER_FEES['cable_tv'].price) }}</span>
              </div>
            </template>
            <br/>
            <div v-if="!CHECKOUT_DATA.chargeInternetAndPhoneFee">
              <template v-if="SERVICE.minimumTerm === 1">
                <strong>
                  {{ ORDER_FEES['internet_and_phone_flex'].name }} in Höhe von {{ this.formatPrice(ORDER_FEES['internet_and_phone_flex'].price) }} wird nicht berechnet.
                </strong>
              </template>
              <template v-else>
                <strong>
                  {{ ORDER_FEES['internet_and_phone'].name }} in Höhe von {{ this.formatPrice(ORDER_FEES['internet_and_phone'].price) }} wird nicht berechnet.
                </strong>
              </template>
            </div>
            <div v-if="!CHECKOUT_DATA.chargeCableTvFee">
              <strong>
              {{ ORDER_FEES['cable_tv'].name }} in Höhe von {{ this.formatPrice(ORDER_FEES['cable_tv'].price) }} wird nicht berechnet.
              </strong>
            </div>
          </p>
          <p class="mt-2">
            <span v-if="CHECKOUT_DATA.invoice_paper">
              Rechnungsversand (monatlich): 2,50 €
            </span>
          </p>
        </template>
        <p class="font-small-1">Alle Preisangaben in € inkl. MwSt.</p>
      </b-col>
      <b-col md="7">
        <template v-if="ADDRESS.funnel_v2">
          <div v-if="getOptionList('phoneOption').length > 0 || getOptionList('phoneOptions').length > 0">
            <product-summary-headline headline="Ihr gewählte Telefonkonfiguration:"/>
            <ul class="list-unstyled">
              <li v-for="option in getOptionList('phoneOption')" :key="option.id">
                <service-option-item-text
                    :service-option-item="option"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :show-price-primary="true"
                />
              </li>
              <li v-for="option in getOptionList('phoneOptions')" :key="option.id">
                <service-option-item-text
                    :service-option-item="option"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :show-price-primary="true"
                    :item-count="option.description == 'Zusätzlicher Sprachkanal' ? CHECKOUT_DATA.countVoiceChannels : 0"
                />
              </li>
            </ul>
          </div>

          <div v-if="getOptionList('payTVOptions').length > 0">
            <product-summary-headline headline="Pay-TV"/>
            <ul class="list-unstyled">
              <li v-for="option in getOptionList('payTVOptions')" :key="option.id">
                <service-option-item-text
                    :service-option-item="option"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :show-price-primary="true"
                />
              </li>
            </ul>
          </div>

          <div v-if="CHECKOUT_DATA.invoice_paper">
            <product-summary-headline headline="Rechnungsversand"/>

            <ul class="list-unstyled">
              <li v-if="CHECKOUT_DATA.invoice_paper">
                <service-option-item-text
                    :service-option-item="{
                        description: 'Rechnungsversand in Papierform per Post',
                        price: 250,
                        item: {
                          baseQuantity: 1
                        },
                        dependencies: [],
                        unit: 'monthly'
                      }"
                    :show-price-primary="true"
                />
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div>
            <p class="font-medium-3">Hardware</p>
            <ul class="list-unstyled">
              <template v-if="Array.isArray(CHECKOUT_DATA.hardwareOptions)">
              <li v-for="serviceOption in CHECKOUT_DATA.hardwareOptions" :key="serviceOption.id">
                {{ serviceOption.description }}:
                <span class="text-primary">{{ formatPrice(serviceOption.price) }}</span>
              </li>
              </template>
              <template v-else>
                <li>
                  <service-option-item-text
                      :service-option-item="CHECKOUT_DATA.hardwareOptions"
                      :product-dependencies="SERVICE.serviceOptionsDependencies"
                      :show-price-primary="true"
                      :show-product-dependencies="CHECKOUT_DATA.hardwareLocale != '1'"
                  />
                </li>
                <li v-if="CHECKOUT_DATA.hardwareLocale === '1'" class="mt-1">
                  <strong>Die Hardware wurde vor Ort an VertragspartnerIn übergeben.</strong><br/>
                  Router-Typ: {{ CHECKOUT_DATA.custom_hardware.router_type }}<br/>
                  CWMP-Account: {{ CHECKOUT_DATA.custom_hardware.cwmp_account }}<br/>
                  CMAC-Adresse: {{ CHECKOUT_DATA.custom_hardware.c_mac_address }}
                </li>
              </template>
              <div v-if="CHECKOUT_DATA.hardwareOptions.length == 0">
                Sie haben keine Hardware ausgewählt.
              </div>
            </ul>
          </div>

          <p class="font-medium-3">Zusatzoptionen</p>

          <ul class="list-unstyled">
            <li v-for="serviceOption in CHECKOUT_DATA.serviceOptions" :key="serviceOption.id">
              <service-option-item-text
                  v-if="serviceOption.id !== CHECKOUT_DATA.hardwareOptions.id"
                  :service-option-item="serviceOption"
                  :product-dependencies="SERVICE.serviceOptionsDependencies"
                  :show-price-primary="true"
              />
            </li>
            <li v-if="CHECKOUT_DATA.booking_service_install_home_network === 1">
              <service-option-item-text
                  :service-option-item="{
                    description: 'Installation einer Glasfaser-Leitung vom Glasfaser-Abschlusspunkt bis in einen Raum der Wohnung (FTTH)',
                    price: 49595,
                    item: {
                      baseQuantity: 1
                    },
                    dependencies: []
                  }"
                  :show-price-primary="true"
              />
            </li>
          </ul>

          <div v-if="CHECKOUT_DATA.serviceOptions.length == 0 && CHECKOUT_DATA.booking_service_install_home_network !== 1">
            Sie haben keine Zusatzoptionen ausgewählt.
          </div>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormGroup,
  BFormInput, BCol, BRow, BFormDatepicker, BFormCheckbox
} from "bootstrap-vue";
import ServiceOptionItemText from "@/components/ServiceOptionItemText";
import ProductSummaryHeadline from "@/views/checkout/summary/ProductSummaryHeadline.vue";

export default {
  name: "ProductSummary",
  components: {
    BFormRadioGroup,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    ServiceOptionItemText,
    ProductSummaryHeadline
  },
  data() {
    return {
      address: {},
      value: [],
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'ORDER_FEES', 'ADDRESS', 'GET_UPGRADE_UPLOAD_SPEED']),
  },
  methods: {
    formatNumber(number) {
      return new Intl.NumberFormat('de-DE').format(number)
    },
    getOptionList(model) {
      const options = this.CHECKOUT_DATA[model] || {}
      return Object.keys(options).reduce((acc, key) => acc.concat(options[key]), [])
    },
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    getPrice() {
      let price = this.SERVICE.priceMonthly
      let serviceOptionsPriceTotal = this.CHECKOUT_DATA.serviceOptions.reduce((acc, item) => {
        if (item.description === 'Zusätzlicher Sprachkanal' && this.CHECKOUT_DATA.countVoiceChannels > 1) {
          for (let i = 1; i <= this.CHECKOUT_DATA.countVoiceChannels; i++) {
            acc += item.price
          }
        } else {
          acc += (item.unit === 'monthly' ? item.price : 0)
        }
        return acc
      }, 0)


      if (this.CHECKOUT_DATA.invoice_paper) {
        serviceOptionsPriceTotal += 250
      }

      return this.formatPrice(price + serviceOptionsPriceTotal)
    },
    getPrice2() {
      let hasDeliveryCosts = false

      let serviceOptionsPriceTotal = this.CHECKOUT_DATA.serviceOptions.reduce((acc, item) => {
        if (item.unit === 'piece') {
          acc += item.price
        }
        if (item.dependencies && item.dependencies.length > 0) {
          if (!(this.isHardware(item) && this.CHECKOUT_DATA.hardwareLocale === '1')) {
            for (let _serviceDependencyId of item.dependencies) {
              const productDependency = this.getProductDependency(_serviceDependencyId)
              if (productDependency && productDependency.mode === 'ONCE') {
                if (productDependency.description === 'Lieferpauschale') {
                  if (hasDeliveryCosts) {
                    continue
                  }
                  hasDeliveryCosts = true
                }
                acc += productDependency.price
              }
            }
          }
        }
        return acc
      }, 0)

      return this.formatPrice(serviceOptionsPriceTotal)
    },
    getCreditNote(id) {
      if (id === 'GS001') {
        return 5000
      } else if (id === 'GS002' || id === 'GS003' || id === 'GS004') {
        return 15000
      } else if (id === 'GSW001' || id === 'GSW002' || id === 'GSW003') {
        return 10000
      }
    },
    hasNoHardware() {

    },
    hasCableTVOption() {
      let hasCableTVOption = false

      for ( const item in this.CHECKOUT_DATA.tvServiceOption ) {
        if (Array.isArray(this.CHECKOUT_DATA.tvServiceOption[item]) && this.CHECKOUT_DATA.tvServiceOption[item].length > 0) hasCableTVOption = true
      }

      return hasCableTVOption
    },
    isHardware(serviceOption) {
      if (Array.isArray(this.CHECKOUT_DATA.hardwareOptions)) {
        return this.CHECKOUT_DATA.hardwareOptions.includes(serviceOption)
      } else {
        return this.CHECKOUT_DATA.hardwareOptions.id === serviceOption.id
      }

      return false
    },
    getProductDependency(id) {
      for (let _productDependency of this.SERVICE.serviceOptionsDependencies) {
        if (_productDependency.id == id) {
          return _productDependency
        }
      }
    },
  },
  mounted() {
    this.CHECKOUT_DATA.serviceOptions = []
    this.CHECKOUT_DATA.serviceOptions = this.CHECKOUT_DATA.serviceOptions

    let services = [];

    this.CHECKOUT_DATA.additionalOptions.forEach((serviceOptionItem) => {
      if (serviceOptionItem.description === 'Zusätzlicher Sprachkanal' && this.CHECKOUT_DATA.countVoiceChannels > 1) {
        for (let i = 1; i <= this.CHECKOUT_DATA.countVoiceChannels; i++) {
          services.push(serviceOptionItem)
        }
      } else {
        services.push(serviceOptionItem)
      }
    })

    Object.keys(this.CHECKOUT_DATA.payTVOptions).forEach((key) => {
      services = services.concat(this.CHECKOUT_DATA.payTVOptions[key])
    })
    Object.keys(this.CHECKOUT_DATA.flatratesOptions).forEach((key) => {
      services = services.concat(this.CHECKOUT_DATA.flatratesOptions[key])
    })
    Object.keys(this.CHECKOUT_DATA.tvServiceOption).forEach((key) => {
      services = services.concat(this.CHECKOUT_DATA.tvServiceOption[key ])
    })
    Object.keys(this.CHECKOUT_DATA.internetOptions).forEach((key) => {
      services = services.concat(this.CHECKOUT_DATA.internetOptions[key])
    })
    Object.keys(this.CHECKOUT_DATA.phoneOption).forEach((key) => {
      services = services.concat(this.CHECKOUT_DATA.phoneOption[key])
    })
    Object.keys(this.CHECKOUT_DATA.phoneOptions).forEach((key) => {
      services = services.concat(this.CHECKOUT_DATA.phoneOptions[key])
    })
    if (this.ADDRESS.funnel_v2 && this.CHECKOUT_DATA.hardwareOptions.length !== 0) {
      services.push(this.CHECKOUT_DATA.hardwareOptions)
    }

    this.CHECKOUT_DATA.serviceOptions = this.CHECKOUT_DATA.serviceOptions.concat(services);
  },
  beforeMount() {
  }
}
</script>

<style scoped>

</style>
